import { gql } from 'graphql-request';
import { ResponsiveImageType } from 'react-datocms';
import { responsiveImage } from '../helpers/imageGeneric';

export const sectionHighlighBannerContentGql = gql`
  name
  identify
  backgroundDesktop {
    hex
  }
  backgroundMobile{
    hex
  }
  imageDesktop {
    ${responsiveImage({ params: { auto: 'format', maxW: 1224, fit: 'fill' } })}
  }
  imageMobile {
    ${responsiveImage({ params: { auto: 'format', maxW: 1224, fit: 'fill' } })}
  }
  clockActive
  clockBackgroundDesktop {
    hex
  }
  clockBackgroundMobile {
    hex
  }
  clockImageDesktop {
    ${responsiveImage({ params: { auto: 'format', maxW: 1224, fit: 'fill' } })}
  }
  clockImageMobile {
    ${responsiveImage({ params: { auto: 'format', maxW: 1224, fit: 'fill' } })}
  }
  endDate
  startDate
  clockActive
  link
`;

export const sectionHighlightBannerDataGql = gql`
  ... on SectionHighlightBannerRecord {
    ${sectionHighlighBannerContentGql}
    _modelApiKey
  }
`;

export type TSectionHighlightBannerData = {
  identify: string;
  name: string;
  link: string;
  backgroundDesktop: { hex: string };
  backgroundMobile: { hex: string };
  imageDesktop: { responsiveImage: ResponsiveImageType };
  imageMobile: { responsiveImage: ResponsiveImageType };
  clockActive: boolean;
  clockBackgroundDesktop: { hex: string };
  clockBackgroundMobile: { hex: string };
  clockImageDesktop: { responsiveImage: ResponsiveImageType };
  clockImageMobile: { responsiveImage: ResponsiveImageType };
  endDate: string;
  startDate: string;
  _modelApiKey?: string;
};
